import React, { useRef, useState } from "react"
import {
  StyleSheet,
} from "@react-pdf/renderer"
import zithasLogo from "../../../assets/images/zithas-dark-logo.png"
import zithasSign from "../../../assets/images/signature.png"
import axios from "axios"
import moment from "moment"
import jsPDF from "jspdf"
import html2canvas from "html2canvas"
import { Modal, Row } from "reactstrap"
import Loader from "pages/Separate/Loader"
import swal from "sweetalert"
import configure from "configure" 


const DownloadContract = ({ contract_id, signature }) => {
  const [description, setDescription] = useState("")
  const [date, setDate] = useState("")
  const [signature_main, setSignature] = useState("")
  const [name, setName] = useState("")
  const [company, setCompany] = useState("")

  const FetchContractData = async () => {
    setViewData(true)
    setLoading(true)
    const formData = new FormData()
    formData.append("contract_id", contract_id)
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/show_contract_data`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then(response => {
        // Filled placeholders keep their {} wrapper; strip it like ViewContract does
        setDescription(
          (response.data.data.contract_data?.template_formate || "")
            .replaceAll("{", "")
            .replaceAll("}", "")
        )
        setDate(response.data.data?.contract_data?.created_at)
        setSignature(response.data.data.contract[0]?.signature)
        setName(response.data.data.contract[0]?.name)
        setCompany(response.data.data.customer?.company)
        setLoading(false)
      })
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }
  const [viewData, setViewData] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const pdfRef = useRef(null)
  

  const generatePDF = async () => {
    try {
      setLoading(true)

      const element = pdfRef.current
      const margin = 10   // mm
      const A4Width = 210  // mm
      const A4Height = 297  // mm
      const contentW = A4Width - margin * 2   // 190mm
      const contentH = A4Height - margin * 2   // 277mm

      // ── 1. Collect safe break Y positions from DOM BEFORE canvas render ────
      //       Use top of every block element as a candidate break point
      const containerRect = element.getBoundingClientRect()
      const blockEls = element.querySelectorAll(
        "p, h1, h2, h3, h4, h5, h6, li, tr, img, table, .section"
      )

      const safeBreaks = new Set([0])
      blockEls.forEach(el => {
        const rect = el.getBoundingClientRect()
        const relTop = rect.top - containerRect.top   // px relative to container (scale 1)
        if (relTop > 0) safeBreaks.add(Math.floor(relTop))
      })

      const sortedBreaks = Array.from(safeBreaks).sort((a, b) => a - b)

      // ── 2. Render full element to canvas at scale 2 ────────────────────────
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        scrollX: 0,
        scrollY: -window.scrollY,
      })

      const scale = 2
      const pxPerMm = canvas.width / contentW          // canvas px per 1mm
      const pageHeightPx = contentH * pxPerMm              // canvas px per A4 content area

      // ── 3. Build page slices — always break at a safe DOM boundary ─────────
      const slices = []
      let currentY = 0

      while (currentY < canvas.height) {
        const maxY = currentY + pageHeightPx

        if (maxY >= canvas.height) {
          slices.push({ start: currentY, end: canvas.height })
          break
        }

        // Find the last safe break point at or before maxY
        // Safe breaks are at scale-1 px; convert to canvas px by multiplying by scale
        const maxYScaleOne = maxY / scale
        let bestBreakScaleOne = maxYScaleOne  // fallback: cut at fixed boundary

        for (let i = sortedBreaks.length - 1; i >= 0; i--) {
          if (
            sortedBreaks[i] <= maxYScaleOne &&
            sortedBreaks[i] > currentY / scale
          ) {
            bestBreakScaleOne = sortedBreaks[i]
            break
          }
        }

        const bestBreakPx = Math.floor(bestBreakScaleOne * scale)
        slices.push({ start: currentY, end: bestBreakPx })
        currentY = bestBreakPx
      }

      // ── 4. Generate PDF — one page per slice ───────────────────────────────
      const pdf = new jsPDF("p", "mm", "a4")

      slices.forEach((slice, i) => {
        if (i > 0) pdf.addPage()

        const sliceHeightPx = slice.end - slice.start

        // Draw just this slice onto a temp canvas
        const pageCanvas = document.createElement("canvas")
        pageCanvas.width = canvas.width
        pageCanvas.height = sliceHeightPx

        const ctx = pageCanvas.getContext("2d")
        ctx.drawImage(
          canvas,
          0, slice.start,    // source: x, y
          canvas.width, sliceHeightPx,  // source: w, h
          0, 0,              // dest: x, y
          canvas.width, sliceHeightPx   // dest: w, h
        )

        const imgData = pageCanvas.toDataURL("image/png")
        const imgHeightMm = sliceHeightPx / pxPerMm  // convert back to mm

        pdf.addImage(imgData, "PNG", margin, margin, contentW, imgHeightMm)
      })

      pdf.save(`Contract-${contract_id}.pdf`)

    } catch (error) {
      console.error("Error generating PDF:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <a
        title="download pdf"
        className="btn btn-sm btn-outline-secondary me-1"
        onClick={() => {
          if (signature == "signed") {
            FetchContractData()
          } else {
            swal({
              icon: "warning",
              text: "The contract has yet to be signed",
            })
          }
        }}
      >
        <i className="fa fa-file-pdf"></i>
      </a>

      <Modal size="xl" centered isOpen={viewData} className="modal-fullscreen">
        <div className="modal-header">
          <h5 className="modal-title mt-0">Download Contract</h5>
          <div className="d-flex align-items-center">
            <div>
              <a title="download pdf" className="" 
                onClick={generatePDF}
              >
                <i className="fa fa-download text-purple pr-10"></i>
              </a>
            </div>
            <button
              type="button"
              onClick={() => {
                setViewData(false)
              }}
              className="btn-modal-close"
              style={{ marginTop: "8px" }}
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>
        </div>
        <div className="modal-body">
          <div
            ref={pdfRef}
            className="p-4"
            style={{ color: "black", marginTop: "20px" }}
          >
            <div className="pb-2 text-center">
              <img src={zithasLogo} height="60" alt="zithasLogo" />
            </div>
            <div>
              <div>
                <div
                  style={{ textAlign: "justify" }}
                  className="Features"
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                />
              </div>

              <h5 className="fw-bold text-decoration-underline">
                Date : {moment(date).format("DD-MM-YYYY")}
              </h5>
              <Row className="mt-4 justify-space-between">
                <div className="col-4">
                  <img src={zithasSign} />
                  <h5 className="mb-0 mt-3">Julius Gohil</h5>
                  <p className="mb-0">Managing Director</p>
                  <p>For Zithas Technologies</p>
                </div>
                <div className="col-4">
                  <img
                    src={signature_main}
                    width="85"
                    style={{ height: "50px", objectFit: "contain" }}
                  />
                  <h5 className="mb-0 ">{name}</h5>
                  <p>For {company}</p>
                </div>
              </Row>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default DownloadContract
